import React from 'react';

const UserTable = ({ users, onEdit, onDelete }) => {
  return (
    <table className="table table-hover table-striped align-middle">
      <thead className="table-primary">
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Role</th>
          <th>Status</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {users.map((user) => (
          <tr key={user.id}>
            <td>{user.name}</td>
            <td>{user.email}</td>
            <td>{user.role}</td>
            <td>
              <span className={`badge ${user.status === 'Active' ? 'bg-success' : 'bg-danger'}`}>
                {user.status}
              </span>
            </td>
            <td>
              <button
                className="btn btn-outline-primary btn-sm me-2"
                onClick={() => onEdit(user)}
              >
                Edit
              </button>
              <button
                className="btn btn-outline-danger btn-sm"
                onClick={() => onDelete(user.id)}
              >
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default UserTable;
